<template>
    <div>
 
        <v-text-field 
            append-icon="mdi-map-marker" 
            outlined 
            background-color="white" 
            :placeholder="$t('prospect_location.address_field_placeholder')" 
            v-model="address" 
            @keyup="onAddressFieldChange()" 
            class="sheet-address-field address-field pointer-events"
        >
        </v-text-field>

        <perfect-scrollbar class="sheet-list-container">

            <v-list dense class="pointer-events sheet-list">
                <v-list-item-group color="primary">
                    <v-list-item v-for="(address, i) in addresses" class="sheet-list-item" :key="i" @click="addressItemClicked(address)">
                        <v-icon class="sheet-list-item-icon"> mdi-map-marker</v-icon>
                        <v-list-item-content :class="`list-content-${i}`">
                            {{ address.description }}
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>

        </perfect-scrollbar>

    </div>
</template>

<script>
import PlacesService from '../../../services/Places';
import ProspectService from '../../../services/models/ProspectService';
import { mapActions, mapGetters } from 'vuex';
import { ADDRESS_SELECTED, INIT_PROSPECT } from '../../../store/mutations';

const prospect_service = ProspectService.build();

export default {

    name: 'DialogAddress',

    computed: {

        ...mapGetters({
            prospect: `ProspectVuex/prospect`,
            gpsOriginalLocation: 'ProspectVuex/gpsOriginalLocation',
        }),

    },

    data() {
        return {
            previousAddress: '',
            addresses: [],
            address: ''
        }
    },

    methods: {

        ...mapActions({
            addressSelected: `ProspectVuex/${ADDRESS_SELECTED}`,
            initProspect: `ProspectVuex/${INIT_PROSPECT}`,
        }),

        async onAddressFieldChange() {

            const createService = new PlacesService(this.map)

            if (this.address !== this.previousAddress) {
                clearTimeout(this.search_timeout);
                this.previousAddress = this.address;

                if (this.address.length > 3) {
                    this.search_timeout = setTimeout(async () => {
                        this.addresses = await createService.findPlace(this.address);
                    }, 250);
                } else {
                    this.addresses = [];
                }
            }
        },

        async addressItemClicked(item) {

            let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

            const createService = new PlacesService(this.map)

            const { address, lat, lng } = await createService.getPlaceDetails(item.id);

            if (!this.prospect) await this.initProspect({ locale: localStorage.locale })

            this.prospect.viability.coordinates = [lng, lat];

            await prospect_service.update(this.prospect);

            this.addressSelected({
                searched_address: address,
                coordinates: { lat, lng },
                status: 'Searched'
            });

            this.$emit('changeSearchMethod', 'Address')
            this.$emit('closeDialogAddress')

            this.address = ''

            this.$emit('changeAddressCoords', { lat, lng })

            this.addresses = [];

            loader.hide();
        },


    }

}
</script>


<style scoped>

    .address-field {
        width: 90%;
        border-radius: 30px;
    }

    .pointer-events {
        pointer-events: all;
    }


    .sheet-address-field {
        min-height: 60px;
        margin: 1em auto 0 !important;
        flex: 0;
    }

    .sheet-list-container {
        flex: 1;
    }

    .sheet-list {
        width: 90%;
        margin: 0 auto;
        height: 100%;
        background-color: transparent !important;
    }

    .sheet-list-item:first-of-type {
        margin-top: 0;
    }

    .sheet-list-item {
        margin: 0.2em 0.5em;
        border: 1px solid black;
        background-color: white;
    }

    .sheet-list-item-icon {
        margin-right: 10px;
    }

    .back-btn {
        margin: 1em;
    }

</style>
